import EventBus from '../../eventbus';
// import mock from './mock';

export default function activity(app, data) {
  // if (data === 'skin' || data === 'theme') {
  //   app.appendMessage({
  //     type: 'options',
  //     body: {
  //       text: 'oh,We offer several kinds of skin ',
  //       hint: 'Please select your skin',
  //       options: [{
  //         text: 'night',
  //       }, {
  //         text: 'hot',
  //       }, {
  //         text: 'default',
  //       }],
  //     },
  //   });
  //   return true;
  // }

  // if (data === 'night') {
  //   app.util.setCss('night', 'https://g.alicdn.com/alicare/alicare-m3/3.1.0/theme_night.css');
  //   return true;
  // }
  // if (data === 'hot') {
  //   app.util.setCss('spring', 'https://g.alicdn.com/alicare/alicare-m3/3.1.0/theme_spring.css');
  //   return true;
  // }
  // if (data === 'default') {
  //   app.util.setCss('normal');
  //   return true;
  // }
  if (data === 'lazada_cancel') {
    EventBus.emit('cancelResult', {
      orderId: '**',
      itemId: '**',
      reason: '**',
      method: '**',
    });
    return true;
  }

  if (data === 'lazada_login') {
    EventBus.emit('login', {
      action: {},
      email: '**',
      type: 'registered  or guest',
      order_number: '***',
    });
    return true;
  }

  if (data === 'lazada_liveagent') {
    EventBus.emit('liveAgent', {
      imSid: '***',
    });
    return true;
  }

  if (data === 'eva') {
    app.appendMessage({
      type: 'evaluate',
      body: {
        title: 'Was it helpful?',
      },
    });
    return true;
  }
  return false;
}



// WEBPACK FOOTER //
// ./src/app/context/channel/robot/activity.js